const styles = {
	wrapper: {},
	fieldWrapper: {
		display: 'flex',
		alignItems: 'center',
		position: 'relative',
		width: '100%',
		input: {
			width: '100%',
			fontSize: 1,
			fontWight: 400,
			borderRadius: 6,
			padding: ['14px 20px 14px 50px', '14px 25px 14px 62px'],
			backgroundColor: 'lightergray',
			borderWidth: '1px',
			borderStyle: 'solid',
			borderColor: 'muted',
			transition: 'border-color 0.2s ease',
			'&:focus': {
				outline: 'none',
				borderColor: 'darkgray',
			},
		},
		svg: {
			position: 'absolute',
			width: 20,
			height: 'auto',
			'&.search-icon': {
				left: [20, 25],
				pointerEvents: 'none',
			},
			'&.close-icon': {
				width: 26,
				height: 26,
				right: 20,
				marginRight: 0,
				cursor: 'pointer',
			},
		},
	},
	searchResult: {
		position: 'absolute',
		zIndex: 10,
		width: '100vw',
		left: 0,
		backgroundColor: 'white',
		minHeight: '100vh',
		padding: [20, 40],
		marginTop: 16,
		boxShadow: '0 2px 4px rgba(41, 41, 41, 0.06)',
		'&.notFound': {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			h2: {
				fontSize: [3, 4],
				color: 'primary',
			},
		},
		'>div': {
			padding: 0,
			marginBottom: 0,
			backgroundColor: 'transparent',
			'>h3': {
				fontSize: [3, 4],
				fontFamily: 'body',
				marginBottom: 30,
			},
		},
	},
};

export default styles;
